import { Client } from "../../core/api-client";
import { API_GET_LATEST_UNSEEN_RELEASE, API_MARK_RELEASE_VIEWED, API_RELEASES } from "../../shared/routes/private.routes";

export const getLatestUnseenRelease = async () => {
  return Client.get(API_GET_LATEST_UNSEEN_RELEASE, { shouldHide: true });
};

export const markReleaseViewed = async (releaseId: string) => {
  return Client.post(API_MARK_RELEASE_VIEWED, { releaseId });
};

export const listReleases = async () => {
  return Client.get(`${API_RELEASES}`);
};

export const createRelease = async (payload: any) => {
  return Client.post(`${API_RELEASES}`, payload);
};

export const updateRelease = async (id: string, payload: any) => {
  return Client.put(`${API_RELEASES}/${id}`, payload);
};

export const deleteRelease = async (id: string) => {
  // Follow existing project pattern: use POST when backend expects POST delete
  return Client.post(`${API_RELEASES}/delete/${id}`, {});
};
